export default __webpack_public_path__ + "static/media/afiliapay.alt.80f8de00.png";